<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ (organization$ | async)?.description }}
        </li>
      </ol>
    </nav>

    <h1 class="page-header-title">
      {{ (organization$ | async)?.description }}
    </h1>
  </header>
  <!-- End Page Header -->

  <div class="row">
    <div class="col-xl-3 mb-3 sidenav-custom-wrap">
      <!-- Nav -->
      <aside class="card navbar-vertical py-2 sidenav-custom">
        <!-- WCAG skip link -->
        <!-- <a
          href="#productContent"
          class="nav-link visually-hidden-focusable d-flex justify-content-center"
          ><span>{{ 'wcag.skipNavigation' | translate }}</span></a
        > -->
        <!-- END WCAG skip link -->
        <tab-menu
          [tabMenuElements]="arrayTabMenuObjects"
          [item]="organization$ | async"
          [itemType]="'organizations'"
        ></tab-menu>
      </aside>
      <!-- End Nav -->
    </div>

    <div class="col-xl" id="productContent">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
